import React from 'react';

/**
 * Small presentational pieces shared by the Title analysis report sections.
 * Light theme only.
 */

export const ReportCard: React.FC<{
  title?: string;
  className?: string;
  testId?: string;
  children: React.ReactNode;
}> = ({ title, className = '', testId, children }) => (
  <section
    data-testid={testId}
    className={`rounded-xl border border-gray-200 bg-white p-[18px] ${className}`.trim()}
  >
    {title ? <h3 className="mb-2 text-base font-bold text-gray-900">{title}</h3> : null}
    {children}
  </section>
);

export const Overline: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="text-[11px] font-bold uppercase tracking-[0.1em] text-gray-500">{children}</div>
);

export const Field: React.FC<{
  label: string;
  children: React.ReactNode;
  className?: string;
}> = ({ label, children, className = '' }) => (
  <div className={className}>
    <div className="text-xs font-bold text-gray-500">{label}</div>
    <div className="text-sm text-gray-900">{children}</div>
  </div>
);

export const TabEmpty: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="rounded-lg border border-dashed border-gray-300 px-4 py-8 text-center text-sm text-gray-600">
    {children}
  </div>
);

export const TableShell: React.FC<{ label: string; children: React.ReactNode }> = ({
  label,
  children,
}) => (
  <div className="overflow-x-auto rounded-lg border border-gray-200">
    <table aria-label={label} className="w-full border-collapse text-left text-sm">
      {children}
    </table>
  </div>
);

export const Th: React.FC<{ children: React.ReactNode; className?: string }> = ({
  children,
  className = '',
}) => (
  <th
    scope="col"
    className={`whitespace-nowrap border-b border-gray-200 bg-gray-50 px-3 py-2 text-[11px] font-bold uppercase tracking-[0.08em] text-gray-500 ${className}`.trim()}
  >
    {children}
  </th>
);

export const Td: React.FC<{
  children: React.ReactNode;
  className?: string;
  mono?: boolean;
}> = ({ children, className = '', mono = false }) => (
  <td
    className={`border-b border-gray-100 px-3 py-2.5 align-top text-gray-700 ${
      mono ? 'font-mono text-xs' : ''
    } ${className}`.trim()}
  >
    {children}
  </td>
);
